// Module
var code = "<div ng-controller=\"secureController as secureCtrl\"> <assessment-viewer content-id=\"secureCtrl.contentId\"></assessment-viewer> </div>";
// Exports
module.exports = code;